<div class="d-flex align-items-center">
    <telxl-avatar
        variant="external-contacts"
        [name]="contact().fullName"
    />
    <div class="font-lg weight-medium truncate pe-2">
        {{ name() }}
    </div>
</div>
